import { useEffect } from "react";
import { useLocation } from "react-router";

function PageNotFound() {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname !== '/chat') {
            sessionStorage.removeItem("persist_session");
        }
    }, [location]);

    return (
        <div className=" d-flex justify-content-center align-items-center pagenotfound">
            <h1>
                NO Page Found
            </h1>
        </div>
    );
}

export default PageNotFound;